import BaseService from './BaseService'
import store from 'src/store'

class SettingsService extends BaseService {

  constructor () {
    super({entity: 'setting'})
  }

  async updateSettings (settings) {
    let dummyId = 1
    await super.update(dummyId, {
      settings
    }, {ignoreNotifications: true})
    store.dispatch('config/getConfig')
    store.dispatch('config/getAppSettings')
  }
}

export default new SettingsService()
